import {track} from 'iq-tracking';

export const trackTakeHomeCardClicked = (slug: string): Promise<void> =>
  track({
    event: 'takehome_card_clicked',
    action: 'click',
    component: 'card',
    content_type: 'takehome',
    content_identifier: slug,
  });

export const trackTakeHomeTopicFilterChanged = (topic: string | undefined): Promise<void> =>
  track({
    event: 'takehome_topic_filter_changed',
    action: 'click',
    component: 'module',
    content_type: 'takehome',
    content_identifier: topic,
  });

export const trackTakeHomeDataDownloaded = (slug: string): Promise<void> =>
  track({
    event: 'takehome_data_downloaded',
    action: 'click',
    component: 'button',
    content_type: 'takehome',
    content_identifier: slug,
  });

export const trackTakeHomePaywallViewed = (gateMode: 'public' | 'free' | 'coder'): Promise<void> =>
  track({
    event: 'takehome_paywall_viewed',
    action: 'view',
    component: 'barrier',
    content_type: 'takehome',
    trigger: gateMode,
  });

export const trackTakeHomeSubscribeClicked = (trigger: 'barrier' | 'banner'): Promise<void> =>
  track({
    event: 'takehome_subscribe_clicked',
    action: 'click',
    component: trigger,
    content_type: 'subscription',
  });

export const trackTakeHomeShareOpened = (trigger: 'barrier' | 'banner'): Promise<void> =>
  track({
    event: 'takehome_share_opened',
    action: 'open',
    component: trigger,
    content_type: 'takehome',
  });

export const trackTakeHomeShareSubmitted = (): Promise<void> =>
  track({
    event: 'takehome_share_submitted',
    action: 'submit',
    component: 'page',
    content_type: 'takehome',
  });

export const trackTakeHomeGradeSubmitted = (slug: string): Promise<void> =>
  track({
    event: 'takehome_grade_submitted',
    action: 'submit',
    component: 'button',
    content_type: 'takehome',
    content_identifier: slug,
  });

export const trackTakeHomeGradeResultViewed = (slug: string, solutionId: number): Promise<void> =>
  track({
    event: 'takehome_grade_result_viewed',
    action: 'view',
    component: 'page',
    content_type: 'takehome',
    content_identifier: slug,
    content_id: solutionId,
  });
